import { Dialog, DialogActions, DialogContent, Grid, Typography } from "@mui/material";
import { APP_NAME } from "app/appConstants";
import { MprcDialogTitleClose } from "components/MprcDialogTitleClose";
import { MprcRequestErrorReport } from "components/MprcRequestErrorReport";
import { MprcRequestIndicator } from "components/MprcRequestIndicator";
import { AboutInfoDto } from "generated/CoreApi_v1";
import moment from "moment";
import { useCoreApi } from "providers/CoreApiProvider";
import { useSession } from "providers/SessionProvider";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { RootPaths } from "routes/RootRouter";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const AboutDialog: React.FC<IProps> = ({ onClose }) => {

    /////////////////////////////////////////////////////////////////////////////////////
    const { t } = useTranslation();
    const api = useCoreApi();

    const [loading, setLoading] = useState<boolean>(true);
    const data = useRef<AboutInfoDto>(null!);
    const lastError = useRef<any>(null);
    const { appBuild } = useSession();

    useEffect(() => {
        async function loadData() {
            try {
                var result = await api.v1.system.aboutInfo();
                data.current = result.data;
            } catch (error) {
                lastError.current = error;
            }
            finally {
                setLoading(false);
            }
        }
        loadData();
    }, []);

    return (
        <Dialog
            open
            fullWidth
            onClose={onClose}
            maxWidth="sm"
            role="dialog"
        >
            <MprcDialogTitleClose onClose={onClose} shrinkPadding />

            <DialogContent>
                {
                    lastError.current
                        ? <MprcRequestErrorReport error={lastError.current} />
                        : loading
                            ? <MprcRequestIndicator type="request" />
                            : (
                                <div>
                                    <Grid container justifyContent="center" alignItems="center" spacing={10}>

                                        <Grid>
                                            <img src={"/img/app/App-Logo-About.png"} alt={APP_NAME} width={192} height={192} />
                                        </Grid>

                                        <Grid size="grow">
                                            {
                                                lastError.current
                                                    ? <MprcRequestErrorReport error={lastError.current} />
                                                    : (
                                                        <div>
                                                            <Typography variant="h1">{data.current.company} &copy;{data.current.copyright}</Typography>


                                                            <Typography variant="body2" mt={2}>
                                                                {t("Public.ReleaseNotes.CurrentApiRelease")}:&nbsp;<b>{data.current.version}</b>
                                                                <br />
                                                                <Typography variant="caption">
                                                                    <i>({moment(data.current.buildDate).utc().format("yyyy-MM-DD HH:mm")})</i>
                                                                </Typography>
                                                            </Typography>

                                                            {appBuild &&
                                                                <Typography variant="body2" mt={2}>
                                                                    {t("Public.ReleaseNotes.CurrentAppRelease")}:&nbsp;
                                                                    <u>
                                                                        <Link onClick={onClose} to={RootPaths.ReleaseNotes}>
                                                                            <b>{appBuild?.buildVersion}</b>
                                                                        </Link>
                                                                    </u>
                                                                    {appBuild?.timestamp &&
                                                                        <>
                                                                            <br />
                                                                            <Typography variant="caption">
                                                                                <i>({moment(appBuild.timestamp).utc().format("yyyy-MM-DD HH:mm")})</i>
                                                                            </Typography>
                                                                        </>}
                                                                </Typography>
                                                            }
                                                        </div>
                                                    )
                                            }
                                        </Grid>
                                    </Grid>

                                </div>
                            )
                }
            </DialogContent>
            <DialogActions />
        </Dialog>
    );
};
